import { render, staticRenderFns } from "./LinkApi.vue?vue&type=template&id=04709f1a&scoped=true"
import script from "./LinkApi.vue?vue&type=script&lang=js"
export * from "./LinkApi.vue?vue&type=script&lang=js"
import style0 from "./LinkApi.vue?vue&type=style&index=0&id=04709f1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04709f1a",
  null
  
)

export default component.exports